import "./ButtonContact.css";
import { RoutesAr } from "../Hooks/RoutesDynamic/RoutesDynamic";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import HButtonBG from "../../Assets/Svg/Header/HButtonBG.svg";
export default function ButtonContactAr({ isScrolled, Text }) {
  const location = useLocation();
  const isArabic = location.pathname.startsWith("/ar");
  return (
    <Link to={RoutesAr.ReachUs} className="Contact_Text">
      <button className={`Contact_Button ${isArabic ? "arabic" : "english"} ${isScrolled ? "CBTscrolled" : ""}`}>
        <div>
          <img src={HButtonBG} alt="" className="HButtonBGImg" />
        </div>
        <div className="HButtonBGButton ar">{Text}</div>
      </button>
    </Link>
  );
}
